import registry from 'rlink-repos/registry';
import {PromotionTile} from 'rlink-promotiles';
import {TwitchConfig} from 'rlink-twitch';
import {PromotionTileIndexer} from './indexers';

export default registry({
  PromotionTile,
  PromotionTileIndexer,
  TwitchConfig
});



// WEBPACK FOOTER //
// ./apps/ingame.companyofheroes.com/src/content.js